import Udesk from 'Udesk';
import SdkLoaderBase from '../../../common/sdk-loader-base';
import UdeskLocales from 'UdeskLocales';

function extend(object, attrs) {
    Reflect.ownKeys(attrs).forEach((key) => {
        Reflect.set(object, key, attrs[key]);
    });
    return object;
}

class SentimentAnalysisComponent extends SdkLoaderBase {
    privates = {
        renderContainerId: 'data-analysis-sentiment-analysis',
        pageTitle: /* 舆情分析 */UdeskLocales['current'].pages.intelligentAnalysis.sentimentAnalysis.index.publicOpinionAnalysis,
    };

    constructor(props) {
        super(props);

        const getRenderToOptions = this.actions.getRenderToOptions;

        extend(this.actions, {
            getRenderToOptions: () => {
                const options = getRenderToOptions.call(this);
                // 这里重新定义sdk传入的方法
                extend(options.methods, {
                    concatQaApiPath: (url) => {
                        const { sdkOptions } = this.props;
                        const httpUrl = Udesk.business.apiPath.concatApiPath(
                            url,
                            sdkOptions,
                            sdkOptions.props.domain
                        );
                        return httpUrl;
                    },
                });
                return options;
            },
        });
    }
}

export default Udesk.react.udeskify(SentimentAnalysisComponent);
